import { apiFetch } from '../services/api';

// Direct API writes for customers — bypass diff-based persist so every save is
// an explicit awaitable operation. Both POST and PUT in api/collection.js are
// idempotent (Firestore .set + SQL ON CONFLICT); fail-closed after commit
// 5180221 so a 500 indicates both stores are in sync (neither wrote) OR SQL
// failed (needs retry). apiFetch auto-retries once for 5xx GETs; callers
// should surface errors for user-driven saves.

/**
 * Create or fully replace a customer record. Returns the saved doc.
 */
export async function saveCustomer(customer) {
  if (!customer?.id) throw new Error('saveCustomer: id required');
  const res = await apiFetch('/api/collection?name=customers', {
    method: 'POST',
    body: customer,
  });
  return res.data;
}

/**
 * Partial update (PATCH-like via PUT) — only provided fields are changed.
 */
export async function updateCustomer(id, updates) {
  if (!id) throw new Error('updateCustomer: id required');
  const res = await apiFetch(`/api/collection?name=customers&id=${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: updates,
  });
  return res.data;
}

/**
 * Permanently delete a customer.
 */
export async function deleteCustomer(id) {
  if (!id) throw new Error('deleteCustomer: id required');
  await apiFetch(`/api/collection?name=customers&id=${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
}
